import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/organisations/{organisationId}/vms-configuration").GET();

export type GetCompanyDepartmentsRes = typeof endpoint.types.Res;

export async function getCompanyVmsConfiguration(params: { organisationId: string }) {
    const call = createCall(endpoint, (r) => fetch(withAccountAuthHeaders(r)));

    return await call({ params });
}
